const state = {
    logs: null,
};

const getters = {
    getLogs(state) {
        return state.logs;
    }
};

const mutations = {
    switchShowReducedRowsButton(state) {
        state.showReducedRows = !state.showReducedRows;
    },
    setLogs(state, logs) {
        state.logs = logs
    }
};

const actions = {
};

export default {
    state,
    getters,
    mutations,
    actions
}
